(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["am-announcement"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (!root || root.dataset.amaReady) return;
    root.dataset.amaReady = '1';
    var key = root.dataset.key;
    try {
      if (sessionStorage.getItem(key) === 'closed' && !(window.Shopify && Shopify.designMode)) {
        root.classList.add('is-closed');
      }
    } catch (e) {}
    var btn = root.querySelector('[data-ama-close]');
    if (btn) {
      btn.addEventListener('click', function () {
        root.classList.add('is-closed');
        try { sessionStorage.setItem(key, 'closed'); } catch (e) {}
      });
    }
  }
  function boot() { document.querySelectorAll('[data-ama]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-am-cats]').forEach(function (el) {
        if (el.getAttribute('data-ready')) return;
        el.setAttribute('data-ready', '1');

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var editing = window.Shopify && window.Shopify.designMode;
        if (reduce || editing || !('IntersectionObserver' in window)) return; // stay visible

        el.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.classList.add('is-visible');
            io.disconnect();
            setTimeout(function () { el.classList.add('is-done'); }, 1100);
          });
        }, { threshold: 0.12 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-collection"] && !Shopify.designMode) return;
  try {
    

(function () {

  var root =
    (window.Shopify &&
     window.Shopify.routes &&
     window.Shopify.routes.root) || '/';


  /* UPDATE CART COUNT */

  function refreshCart() {

    fetch(root + 'cart.js', {
      headers: {
        Accept: 'application/json'
      }
    })
    .then(function (response) {
      return response.json();
    })
    .then(function (cart) {

      document.querySelectorAll('.am-count').forEach(function (el) {
        el.textContent = cart.item_count;
      });

    })
    .catch(function () {});

  }


  /* INITIALIZE SECTION */

  function init(sec) {

    if (!sec || sec.dataset.amclReady) {
      return;
    }

    sec.dataset.amclReady = '1';

    var form = sec.querySelector('[data-amcl-form]');

    var scrim = sec.querySelector('.amcl__scrim');

    var desktop = function () {
      return window.matchMedia('(min-width: 981px)').matches;
    };


    /* FILTER FORM */

    function send() {

      if (!form) {
        return;
      }

      form.querySelectorAll('input[type="number"]').forEach(function (input) {
        input.disabled = input.value === '';
      });

      form.submit();

    }


    if (form) {

      var timer;

      /* AUTO APPLY FILTERS ON DESKTOP */

      form.addEventListener('change', function () {

        if (!desktop()) {
          return;
        }

        clearTimeout(timer);

        timer = setTimeout(send, 250);

      });


      form.addEventListener('submit', function () {

        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          input.disabled = input.value === '';
        });

      });


      /* RESTORE PRICE INPUTS ON BACK NAVIGATION */

      window.addEventListener('pageshow', function () {

        form.querySelectorAll('input[type="number"]').forEach(function (input) {
          input.disabled = false;
        });

      });


      /* MOBILE FILTER DRAWER */

      var openBtn = sec.querySelector('[data-amcl-open]');

      var lastFocus = null;

      var open = function () {

        if (!scrim) {
          return;
        }

        lastFocus = document.activeElement;

        scrim.hidden = false;

        form.classList.add('is-open');

        requestAnimationFrame(function () {
          scrim.classList.add('is-open');
        });

        document.documentElement.style.overflow = 'hidden';

        var focusTarget = form.querySelector('button, summary, input');

        if (focusTarget) {
          focusTarget.focus();
        }

      };


      var close = function () {

        form.classList.remove('is-open');

        if (scrim) {
          scrim.classList.remove('is-open');
        }

        document.documentElement.style.overflow = '';

        setTimeout(function () {

          if (scrim && !form.classList.contains('is-open')) {
            scrim.hidden = true;
          }

        }, 250);

        if (lastFocus) {
          lastFocus.focus();
        }

      };


      if (openBtn) {

        openBtn.addEventListener('click', open);

      }


      sec.querySelectorAll('[data-amcl-close]').forEach(function (button) {

        button.addEventListener('click', close);

      });


      document.addEventListener('keydown', function (event) {

        if (
          event.key === 'Escape' &&
          form.classList.contains('is-open')
        ) {
          close();
        }

      });


      window.addEventListener('resize', function () {

        if (
          desktop() &&
          form.classList.contains('is-open')
        ) {
          close();
        }

      });

    }


    /* COLLECTION SORTING */

    var sort = sec.querySelector('[data-amcl-sort]');

    if (sort) {

      sort.addEventListener('change', function () {

        if (form) {
          send();
          return;
        }

        var url = new URL(window.location.href);

        url.searchParams.set('sort_by', sort.value);

        url.searchParams.delete('page');

        window.location.href =
          url.pathname +
          url.search +
          '#amcl-results-' +
          sec.id.replace(/^am-/, '');

      });

    }


    /* CENTER ACTIVE CATEGORY CHIP */

    var activeChip = sec.querySelector('.amcl__chip.is-on');

    var chipRow = sec.querySelector('.amcl__chips-in');

    if (activeChip && chipRow) {

      chipRow.scrollLeft =
        activeChip.offsetLeft -
        (chipRow.clientWidth - activeChip.offsetWidth) / 2;

    }


    /* AJAX ADD TO CART */

    sec.addEventListener('submit', function (event) {

      var addForm = event.target.closest('[data-amcl-add]');

      if (!addForm) {
        return;
      }

      event.preventDefault();

      var button = addForm.querySelector('button');

      if (!button || button.disabled) {
        return;
      }

      var originalLabel = button.textContent;

      button.disabled = true;

      button.textContent = 'Adding...';

      var addUrl =
        addForm.getAttribute('action').replace(/\/$/, '') + '.js';

      fetch(addUrl, {

        method: 'POST',

        body: new FormData(addForm),

        headers: {
          Accept: 'application/json'
        }

      })
      .then(function (response) {

        if (!response.ok) {
          throw new Error('Add to cart failed');
        }

        return response.json();

      })
      .then(function () {

        button.textContent = 'Added';

        button.classList.add('is-done');

        refreshCart();

        setTimeout(function () {

          button.textContent = originalLabel;

          button.classList.remove('is-done');

          button.disabled = false;

        }, 1400);

      })
      .catch(function () {

        button.disabled = false;

        button.textContent = 'Try again';

        setTimeout(function () {
          button.textContent = originalLabel;
        }, 2200);

      });

    });

  }


  /* INITIAL PAGE LOAD */

  function boot() {

    document.querySelectorAll('[data-amcl]').forEach(init);

  }


  if (document.readyState === 'loading') {

    document.addEventListener('DOMContentLoaded', boot);

  } else {

    boot();

  }


  /* SHOPIFY THEME EDITOR SUPPORT */

  document.addEventListener('shopify:section:load', function (event) {

    var element = event.target.matches('[data-amcl]')
      ? event.target
      : event.target.querySelector('[data-amcl]');

    init(element);

  });

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-contact-page"] && !Shopify.designMode) return;
  try {
    
(function () {
  function reveal() {
    var els = document.querySelectorAll('.amcp [data-reveal]:not(.is-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12 });
    els.forEach(function (e) { io.observe(e); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', reveal);
  else reveal();
  document.addEventListener('shopify:section:load', reveal);

  // after a successful send, bring the confirmation into view
  document.addEventListener('DOMContentLoaded', function () {
    var ok = document.querySelector('.amcp__ok, .amcp__err');
    if (ok) ok.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-featured-collection"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function refreshCartCount() {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.am-count').forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {});
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-am-fc]').forEach(function (el) {
        if (el.getAttribute('data-ready')) return;
        el.setAttribute('data-ready', '1');

        /* Add to cart without leaving the page. Falls back to a normal form post on any problem. */
        el.addEventListener('submit', function (e) {
          var form = e.target.closest('[data-am-add]');
          if (!form) return;
          e.preventDefault();
          var btn = form.querySelector('button');
          if (!btn || btn.disabled) return;
          var label = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch(form.getAttribute('action') + '.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' }
          })
            .then(function (r) {
              if (!r.ok) throw new Error('add failed');
              return r.json();
            })
            .then(function () {
              btn.textContent = 'Added';
              btn.classList.add('is-done');
              refreshCartCount();
              setTimeout(function () {
                btn.textContent = label;
                btn.classList.remove('is-done');
                btn.disabled = false;
              }, 1400);
            })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = label;
              form.submit();
            });
        });

        /* Scroll-in animation */
        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var editing = window.Shopify && window.Shopify.designMode;
        if (reduce || editing || !('IntersectionObserver' in window)) return; // stay visible

        el.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.classList.add('is-visible');
            io.disconnect();
            setTimeout(function () { el.classList.add('is-done'); }, 1200);
          });
        }, { threshold: 0.1 });
        io.observe(el);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  function refreshCart() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('.am-count').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }

  function init(sec) {
    if (!sec || sec.dataset.apdReady) return;
    sec.dataset.apdReady = '1';

    var $ = function (s) { return sec.querySelector(s); };
    var $$ = function (s) { return Array.prototype.slice.call(sec.querySelectorAll(s)); };
    var data = {};
    try { data = JSON.parse($('[data-apd-data]').textContent); } catch (e) {}
    var variants = data.variants || [];
    var form = $('[data-apd-form]') || $('form');
    var idInput = $('[data-apd-id]');
    var addBtn = $('[data-apd-add]');
    var sAdd = $('[data-apd-sadd]');
    var msg = $('[data-apd-msg]');
    var qty = $('[data-apd-qty]');
    var toastEl = $('[data-apd-toast]');
    var wa = $('[data-apd-wa]');
    var label = addBtn ? addBtn.dataset.label : 'Add to cart';
    var current = null;

    /* ---------- gallery ---------- */
    var slides = $$('.apd__slide'), thumbs = $$('[data-apd-th]'), idx = 0, counter = $('[data-apd-count]');
    slides.forEach(function (s, i) { if (s.classList.contains('is-on')) idx = i; });
    function show(i) {
      if (!slides.length) return;
      idx = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) { s.classList.toggle('is-on', k === idx); });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === idx); t.setAttribute('aria-pressed', k === idx); });
      if (counter) counter.textContent = (idx + 1) + ' / ' + slides.length;
      var th = thumbs[idx]; if (th && th.scrollIntoView) { try { th.scrollIntoView({ block: 'nearest', inline: 'nearest' }); } catch (e) {} }
    }
    thumbs.forEach(function (t, i) { t.addEventListener('click', function () { show(i); }); });
    var pv = $('[data-apd-prev]'), nx = $('[data-apd-next]');
    if (pv) pv.addEventListener('click', function () { show(idx - 1); });
    if (nx) nx.addEventListener('click', function () { show(idx + 1); });
    var stage = $('[data-apd-stage]'), sx = null;
    if (stage) {
      stage.addEventListener('touchstart', function (e) { sx = e.touches[0].clientX; }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        if (sx === null) return;
        var dx = e.changedTouches[0].clientX - sx; sx = null;
        if (Math.abs(dx) > 40) show(dx < 0 ? idx + 1 : idx - 1);
      });
      stage.addEventListener('mousemove', function (e) {
        var r = stage.getBoundingClientRect();
        stage.style.setProperty('--zx', ((e.clientX - r.left) / r.width * 100) + '%');
        stage.style.setProperty('--zy', ((e.clientY - r.top) / r.height * 100) + '%');
      });
    }

    /* ---------- variants ---------- */
    function selected() {
      return $$('[data-apd-opt]').map(function (fs) {
        var r = fs.querySelector('.apd__radio:checked'); return r ? r.value : null;
      });
    }
    function find(opts) {
      if (!opts.length) return variants[0] || null;
      return variants.filter(function (v) {
        return v.options.every(function (o, i) { return o === opts[i]; });
      })[0] || null;
    }
    function markOff() {
      var opts = selected();
      $$('[data-apd-opt]').forEach(function (fs, p) {
        fs.querySelectorAll('.apd__radio').forEach(function (r) {
          var test = opts.slice(); test[p] = r.value;
          var v = find(test);
          var lbl = r.nextElementSibling;
          if (lbl) lbl.classList.toggle('is-off', !v || !v.available);
        });
      });
    }
    function setBtn(btn, text, disabled) { if (!btn) return; btn.disabled = disabled; var s = btn.querySelector('span'); (s || btn).textContent = text; }
    function waLink() {
      if (!wa) return;
      var opts = selected().filter(Boolean).join(' / ');
      var text = 'Hi, I want to order: ' + sec.dataset.title + (opts ? ' (' + opts + ')' : '') + ' x' + (qty ? qty.value : 1) + ' ' + location.href.split('?')[0];
      wa.href = sec.dataset.wa + encodeURIComponent(text);
    }
    function update() {
      var v = find(selected());
      current = v;
      $$('[data-apd-opt]').forEach(function (fs) {
        var r = fs.querySelector('.apd__radio:checked'), b = fs.querySelector('legend b');
        if (r && b) b.textContent = r.value;
      });
      markOff();
      if (!v) {
        setBtn(addBtn, 'Unavailable', true);
        if (sAdd) { sAdd.disabled = true; sAdd.textContent = 'Unavailable'; }
        waLink(); return;
      }
      if (idInput) idInput.value = v.id;
      var price = $('[data-apd-price]'), cmp = $('[data-apd-compare]'), sv = $('[data-apd-save]'), sp = $('[data-apd-sprice]');
      if (price) price.textContent = v.price;
      if (sp) sp.textContent = v.price;
      if (cmp) { cmp.hidden = !v.compare; if (v.compare) cmp.textContent = v.compare; }
      if (sv) { sv.hidden = !v.save; if (v.save) sv.textContent = 'Save ' + v.save; }
      setBtn(addBtn, v.available ? label : 'Sold out', !v.available);
      if (sAdd) { sAdd.disabled = !v.available; sAdd.textContent = v.available ? label : 'Sold out'; }
      if (v.media) {
        slides.forEach(function (s, k) { if (String(s.dataset.media) === String(v.media)) show(k); });
      }
      if (msg) msg.hidden = true;
      try { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState({}, '', u.toString()); } catch (e) {}
      waLink();
    }
    $$('.apd__radio').forEach(function (r) { r.addEventListener('change', update); });
    update();

    /* ---------- quantity ---------- */
    function setQty(n) { if (!qty) return; qty.value = Math.max(1, Math.min(10, n || 1)); waLink(); }
    var mi = $('[data-apd-minus]'), pl = $('[data-apd-plus]');
    if (mi) mi.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) - 1); });
    if (pl) pl.addEventListener('click', function () { setQty((parseInt(qty.value, 10) || 1) + 1); });
    if (qty) qty.addEventListener('change', function () { setQty(parseInt(qty.value, 10)); });

    /* ---------- add to cart ---------- */
    var tt;
    function toast(t) { if (!toastEl) return; toastEl.textContent = t; toastEl.classList.add('is-on'); clearTimeout(tt); tt = setTimeout(function () { toastEl.classList.remove('is-on'); }, 2400); }
    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        if (msg) msg.hidden = true;
        var span = addBtn.querySelector('span') || addBtn;
        addBtn.disabled = true; span.textContent = 'Adding...';
        fetch((window.Shopify && Shopify.routes ? Shopify.routes.root : '/') + 'cart/add.js', {
          method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' }
        })
          .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
          .then(function (res) {
            if (!res.ok) throw new Error(res.j.description || res.j.message || 'Could not add this item');
            span.textContent = 'Added'; addBtn.classList.add('is-done'); addBtn.disabled = false;
            toast('Added to your cart');
            refreshCart();
            setTimeout(function () { addBtn.classList.remove('is-done'); span.textContent = label; }, 1500);
          })
          .catch(function (err) {
            addBtn.disabled = false; span.textContent = label;
            if (msg) { msg.textContent = err.message; msg.hidden = false; }
          });
      });
    }
    if (sAdd && addBtn) sAdd.addEventListener('click', function () { addBtn.click(); });

    /* sticky bar shows once the main button scrolls above the screen */
    var sbar = $('[data-apd-sbar]');
    if (sbar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        var out = !es[0].isIntersecting && es[0].boundingClientRect.top < 0;
        sbar.classList.toggle('is-on', out); sbar.setAttribute('aria-hidden', out ? 'false' : 'true');
        if (sAdd) sAdd.tabIndex = out ? 0 : -1;
      }).observe(addBtn);
    }
  }

  function boot() { document.querySelectorAll('[data-apd]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-apd]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-promo-banner"] && !Shopify.designMode) return;
  try {
    

  (function () {

    function init(scope) {

      (scope || document)
        .querySelectorAll('[data-am-pb]')
        .forEach(function (el) {

          if (el.getAttribute('data-ready')) return;

          el.setAttribute('data-ready', '1');

          var reduce =
            window.matchMedia &&
            window.matchMedia(
              '(prefers-reduced-motion: reduce)'
            ).matches;

          var editing =
            window.Shopify &&
            window.Shopify.designMode;

          if (
            reduce ||
            editing ||
            !('IntersectionObserver' in window)
          ) {
            return;
          }

          el.classList.add('is-ready');

          var io = new IntersectionObserver(
            function (entries) {

              entries.forEach(function (entry) {

                if (!entry.isIntersecting) return;

                el.classList.add('is-visible');

                io.disconnect();

              });

            },
            { threshold: 0.15 }
          );

          io.observe(el);

        });

    }

    init();

    document.addEventListener(
      'shopify:section:load',
      function (e) {
        init(e.target);
      }
    );

  })();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-reels"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(sec) {
    if (!sec || sec.dataset.amrlReady === 'true') return;
    sec.dataset.amrlReady = 'true';

    var track = sec.querySelector('[data-amrl-track]');
    var prev = sec.querySelector('[data-amrl-prev]');
    var next = sec.querySelector('[data-amrl-next]');
    var dlg = sec.querySelector('[data-amrl-dlg]');
    var stage = sec.querySelector('[data-amrl-stage]');
    var shop = sec.querySelector('[data-amrl-shop]');
    var closeButton = sec.querySelector('[data-amrl-close]');
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var editing = Boolean(window.Shopify && window.Shopify.designMode);
    var observer = null;
    var lastFocus = null;
    var previousOverflow = '';

    if (reduce || editing || !('IntersectionObserver' in window)) {
      sec.classList.add('is-in');
    } else {
      sec.classList.add('amrl--will-animate');
      observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            sec.classList.add('is-in');
            observer.disconnect();
          }
        });
      }, { threshold: 0.12 });
      observer.observe(sec);
    }

    function updateArrows() {
      if (!track || !prev || !next) return;
      prev.disabled = track.scrollLeft <= 3;
      next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 3;
    }

    function go(direction) {
      if (!track) return;
      var item = track.querySelector('.amrl__item');
      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap) || 0;
      var step = item ? (item.getBoundingClientRect().width + gap) * 2 : track.clientWidth;
      track.scrollBy({ left: direction * step, behavior: reduce ? 'auto' : 'smooth' });
    }

    if (track && prev && next) {
      prev.addEventListener('click', function () { go(-1); });
      next.addEventListener('click', function () { go(1); });
      track.addEventListener('scroll', updateArrows, { passive: true });
      window.addEventListener('resize', updateArrows);
      updateArrows();
    }

    var videos = sec.querySelectorAll('.amrl__card video.amrl__vid');

    function pausePreviews() {
      videos.forEach(function (video) { video.pause(); });
    }

    if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
      sec.querySelectorAll('.amrl__card').forEach(function (card) {
        var video = card.querySelector('.amrl__vid');
        if (!video) return;
        card.addEventListener('mouseenter', function () {
          if (dlg && dlg.open) return;
          var playback = video.play();
          if (playback && playback.catch) playback.catch(function () {});
        });
        card.addEventListener('mouseleave', function () {
          video.pause();
          if (video.readyState > 0) video.currentTime = 0;
        });
      });
    }

    function cleanup() {
      if (stage) stage.replaceChildren();
      document.documentElement.style.overflow = previousOverflow;
      if (lastFocus && lastFocus.isConnected) lastFocus.focus();
      lastFocus = null;
    }

    function closeDlg() {
      if (!dlg || !dlg.open) return;
      if (typeof dlg.close === 'function') dlg.close();
      else {
        dlg.removeAttribute('open');
        cleanup();
      }
    }

    function openDlg(button) {
      if (!dlg || !stage || dlg.open) return;
      var kind = button.dataset.kind;
      var src = button.dataset.src;
      var player;
      if (!src || (kind !== 'file' && kind !== 'youtube' && kind !== 'vimeo')) return;

      pausePreviews();
      lastFocus = button;
      stage.replaceChildren();

      if (kind === 'file') {
        player = document.createElement('video');
        player.src = src;
        player.controls = true;
        player.autoplay = true;
        player.playsInline = true;
        player.setAttribute('playsinline', '');
      } else {
        player = document.createElement('iframe');
        player.allow = 'autoplay; fullscreen; picture-in-picture';
        player.allowFullscreen = true;
        player.title = button.dataset.title || 'Reel';
        player.referrerPolicy = 'strict-origin-when-cross-origin';
        if (kind === 'youtube') {
          player.src = 'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(src) + '?autoplay=1&rel=0&playsinline=1';
        } else {
          player.src = 'https://player.vimeo.com/video/' + encodeURIComponent(src) + '?autoplay=1&playsinline=1';
        }
      }

      stage.appendChild(player);
      if (shop) {
        if (button.dataset.url) {
          shop.href = button.dataset.url;
          shop.hidden = false;
        } else {
          shop.hidden = true;
          shop.removeAttribute('href');
        }
      }

      previousOverflow = document.documentElement.style.overflow;
      if (typeof dlg.showModal === 'function') dlg.showModal();
      else dlg.setAttribute('open', '');
      document.documentElement.style.overflow = 'hidden';

      if (kind === 'file') {
        var playback = player.play();
        if (playback && playback.catch) playback.catch(function () {});
      }
    }

    if (dlg && stage) {
      sec.querySelectorAll('[data-amrl-open]').forEach(function (button) {
        button.addEventListener('click', function () { openDlg(button); });
      });
      if (closeButton) closeButton.addEventListener('click', closeDlg);
      dlg.addEventListener('click', function (event) {
        if (event.target === dlg) closeDlg();
      });
      dlg.addEventListener('close', cleanup);
    }

    sec.amrlDestroy = function () {
      if (observer) observer.disconnect();
      window.removeEventListener('resize', updateArrows);
      if (dlg && dlg.open) closeDlg();
      pausePreviews();
      delete sec.dataset.amrlReady;
    };
  }

  function boot() {
    document.querySelectorAll('[data-amrl]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var sec = event.target.matches && event.target.matches('[data-amrl]')
      ? event.target
      : event.target.querySelector('[data-amrl]');
    init(sec);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var sec = event.target.matches && event.target.matches('[data-amrl]')
      ? event.target
      : event.target.querySelector('[data-amrl]');
    if (sec && sec.amrlDestroy) sec.amrlDestroy();
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target.closest && event.target.closest('.amrl__item');
    if (!item) return;
    var sec = item.closest('[data-amrl]');
    if (!sec) return;
    sec.classList.add('is-in');
    item.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-related-products"] && !Shopify.designMode) return;
  try {
    
(function () {
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function refreshCart() {
    fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { document.querySelectorAll('.am-count').forEach(function (el) { el.textContent = c.item_count; }); })
      .catch(function () {});
  }
  function init(sec) {
    if (!sec || sec.dataset.aprReady) return;
    sec.dataset.aprReady = '1';

    /* automatic recommendations load after the page */
    var url = sec.dataset.url;
    if (url) {
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var src = doc.querySelector('[data-apr-root]');
          var mine = sec.querySelector('[data-apr-root]');
          if (src && mine && src.querySelector('.apr__card')) { mine.innerHTML = src.innerHTML; sec.hidden = false; }
        })
        .catch(function () {});
    }

    /* add to cart without leaving the page */
    sec.addEventListener('submit', function (e) {
      var f = e.target.closest('[data-apr-add]');
      if (!f) return;
      e.preventDefault();
      var btn = f.querySelector('button');
      if (!btn || btn.disabled) return;
      var label = btn.textContent;
      btn.disabled = true; btn.textContent = 'Adding...';
      fetch(f.getAttribute('action') + '.js', { method: 'POST', body: new FormData(f), headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
        .then(function () {
          btn.textContent = 'Added'; btn.classList.add('is-done'); refreshCart();
          setTimeout(function () { btn.textContent = label; btn.classList.remove('is-done'); btn.disabled = false; }, 1400);
        })
        .catch(function () { btn.disabled = false; btn.textContent = label; f.submit(); });
    });
  }
  function boot() { document.querySelectorAll('[data-apr]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', function (e) { init(e.target.querySelector('[data-apr]')); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-reviews"] && !Shopify.designMode) return;
  try {
    

(function () {

  function init(sec) {

    if (!sec || sec.dataset.amrvReady) {
      return;
    }

    sec.dataset.amrvReady = '1';

    var reduce =
      window.matchMedia &&
      window.matchMedia(
        '(prefers-reduced-motion: reduce)'
      ).matches;

    var editing =
      window.Shopify &&
      window.Shopify.designMode;

    /* SCROLL REVEAL */

    if (
      reduce ||
      editing ||
      !('IntersectionObserver' in window)
    ) {

      sec.classList.add('is-in');

    } else {

      var io = new IntersectionObserver(
        function (entries) {

          entries.forEach(function (entry) {

            if (entry.isIntersecting) {

              sec.classList.add('is-in');

              io.disconnect();

            }

          });

        },
        {
          threshold: 0.08
        }
      );

      io.observe(sec);

    }


    /* SHOW MORE REVIEWS */

    var more = sec.querySelector(
      '[data-amrv-more]'
    );

    if (more) {

      more.addEventListener(
        'click',
        function () {

          sec.classList.add('is-open');

        }
      );

    }


    /* REVIEW IMAGE VIEWER */

    var dlg = sec.querySelector(
      '[data-amrv-dlg]'
    );

    var img = sec.querySelector(
      '[data-amrv-img]'
    );

    var count = sec.querySelector(
      '[data-amrv-count]'
    );

    var cards = [];

    var idx = 0;

    var lastFocus = null;


    /* GET VISIBLE REVIEWS */

    function list() {

      cards = Array.prototype.slice.call(
        sec.querySelectorAll(
          '[data-amrv-open]'
        )
      ).filter(function (card) {

        return card.getClientRects().length > 0;

      });

    }


    /* DISPLAY SELECTED REVIEW */

    function show(i) {

      if (!cards.length) {
        return;
      }

      idx =
        (i + cards.length) %
        cards.length;

      img.src =
        cards[idx].dataset.full;

      img.alt =
        cards[idx].dataset.alt || '';

      count.textContent =
        (idx + 1) +
        ' / ' +
        cards.length;

    }


    /* OPEN FULL SIZE VIEWER */

    function open(card) {

      list();

      lastFocus = card;

      show(cards.indexOf(card));

      if (dlg.showModal) {

        dlg.showModal();

      } else {

        dlg.setAttribute(
          'open',
          ''
        );

        document.documentElement.style.overflow =
          'hidden';

      }

    }


    if (dlg) {

      /* CLICK ANY REVIEW */

      sec.querySelectorAll(
        '[data-amrv-open]'
      ).forEach(function (card) {

        card.addEventListener(
          'click',
          function () {

            open(card);

          }
        );

      });


      /* CLOSE VIEWER */

      sec.querySelector(
        '[data-amrv-close]'
      ).addEventListener(
        'click',
        function () {

          if (dlg.close) {
            dlg.close();
          } else {
            dlg.removeAttribute('open');
            document.documentElement.style.overflow = '';
            img.removeAttribute('src');
            if (lastFocus && lastFocus.focus) {
              lastFocus.focus();
            }
          }

        }
      );


      /* PREVIOUS REVIEW */

      sec.querySelector(
        '[data-amrv-prev]'
      ).addEventListener(
        'click',
        function () {

          show(idx - 1);

        }
      );


      /* NEXT REVIEW */

      sec.querySelector(
        '[data-amrv-next]'
      ).addEventListener(
        'click',
        function () {

          show(idx + 1);

        }
      );


      /* CLICK BACKDROP TO CLOSE */

      dlg.addEventListener(
        'click',
        function (event) {

          if (event.target === dlg) {

            if (dlg.close) {
              dlg.close();
            } else {
              dlg.removeAttribute('open');
              document.documentElement.style.overflow = '';
              img.removeAttribute('src');
            }

          }

        }
      );


      /* RESTORE FOCUS AFTER CLOSE */

      dlg.addEventListener(
        'close',
        function () {

          document.documentElement.style.overflow =
            '';

          img.removeAttribute('src');

          if (
            lastFocus &&
            lastFocus.focus
          ) {

            lastFocus.focus();

          }

        }
      );


      /* KEYBOARD NAVIGATION */

      dlg.addEventListener(
        'keydown',
        function (event) {

          if (event.key === 'ArrowLeft') {

            event.preventDefault();

            show(idx - 1);

          }

          if (event.key === 'ArrowRight') {

            event.preventDefault();

            show(idx + 1);

          }

          if (
            event.key === 'Escape' &&
            !dlg.close
          ) {

            dlg.removeAttribute('open');

            document.documentElement.style.overflow = '';

            img.removeAttribute('src');

          }

        }
      );

    }

  }


  /* INITIALIZE SECTIONS */

  function boot() {

    document.querySelectorAll(
      '[data-amrv]'
    ).forEach(init);

  }


  if (
    document.readyState === 'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      boot
    );

  } else {

    boot();

  }


  /* SHOPIFY THEME EDITOR SUPPORT */

  document.addEventListener(
    'shopify:section:load',
    function (event) {

      var target = event.target;

      if (!target) {
        return;
      }

      if (
        target.matches &&
        target.matches('[data-amrv]')
      ) {

        init(target);

      }

      target.querySelectorAll(
        '[data-amrv]'
      ).forEach(init);

    }
  );

})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-trust"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-am-trust]').forEach(function (el) {
        if (el.getAttribute('data-ready')) return;
        el.setAttribute('data-ready', '1');

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var editing = window.Shopify && window.Shopify.designMode;
        if (reduce || editing || !('IntersectionObserver' in window)) return; // stay visible

        el.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.classList.add('is-visible');
            io.disconnect();
            setTimeout(function () { el.classList.add('is-done'); }, 900);
          });
        }, { threshold: 0.2 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-why-us"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init(scope) {
      (scope || document).querySelectorAll('[data-am-why]').forEach(function (el) {
        if (el.getAttribute('data-ready')) return;
        el.setAttribute('data-ready', '1');

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var editing = window.Shopify && window.Shopify.designMode;
        if (reduce || editing || !('IntersectionObserver' in window)) return; // stay visible

        el.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.classList.add('is-visible');
            io.disconnect();
            setTimeout(function () { el.classList.add('is-done'); }, 1300);
          });
        }, { threshold: 0.15 });
        io.observe(el);
      });
    }
    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["am-women-bags"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    function refreshCartCount() {
      fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.querySelectorAll('.am-count').forEach(function (el) { el.textContent = cart.item_count; });
        })
        .catch(function () {});
    }

    function init(scope) {
      (scope || document).querySelectorAll('[data-am-wb]').forEach(function (el) {
        if (el.getAttribute('data-ready')) return;
        el.setAttribute('data-ready', '1');

        /* Add to cart without leaving the page; falls back to a normal form post on any problem. */
        el.addEventListener('submit', function (e) {
          var form = e.target.closest('[data-am-add]');
          if (!form) return;
          e.preventDefault();
          var btn = form.querySelector('button');
          if (!btn || btn.disabled) return;
          var label = btn.textContent;
          btn.disabled = true;
          btn.textContent = 'Adding...';

          fetch(form.getAttribute('action') + '.js', {
            method: 'POST',
            body: new FormData(form),
            headers: { Accept: 'application/json' }
          })
            .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
            .then(function () {
              btn.textContent = 'Added';
              btn.classList.add('is-done');
              refreshCartCount();
              setTimeout(function () {
                btn.textContent = label;
                btn.classList.remove('is-done');
                btn.disabled = false;
              }, 1400);
            })
            .catch(function () {
              btn.disabled = false;
              btn.textContent = label;
              form.submit();
            });
        });

        var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var editing = window.Shopify && window.Shopify.designMode;
        if (reduce || editing || !('IntersectionObserver' in window)) return; // stay visible

        el.classList.add('is-ready');
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            el.classList.add('is-visible');
            io.disconnect();
            setTimeout(function () { el.classList.add('is-done'); }, 1400);
          });
        }, { threshold: 0.12 });
        io.observe(el);
      });
    }

    init();
    document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
